"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionTintFor = exports.sectionIconFor = exports.IconLock = exports.IconPencil = exports.IconPrinter = exports.IconUpload = exports.IconInfo = exports.IconShield = exports.IconCamera = exports.IconCreditCard = exports.IconAlertCircle = exports.IconArrowLeft = exports.IconChevronRight = exports.IconChevronLeft = exports.IconCheck = exports.IconClipboard = exports.IconBriefcase = exports.IconInformation = exports.IconMegaphone = exports.IconDocument = exports.IconMapPin = exports.IconAcademicCap = exports.IconUsers = exports.IconUser = void 0;
const react_1 = __importDefault(require("react"));
const make = (path) => ({ size = 20, className, strokeWidth = 1.75 }) => (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", className: className, "aria-hidden": "true" }, path));
exports.IconUser = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
    react_1.default.createElement("circle", { cx: "12", cy: "7", r: "4" })));
exports.IconUsers = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
    react_1.default.createElement("circle", { cx: "9", cy: "7", r: "4" }),
    react_1.default.createElement("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }),
    react_1.default.createElement("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })));
exports.IconAcademicCap = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M22 10v6" }),
    react_1.default.createElement("path", { d: "M12 2 2 8l10 6 10-6-10-6Z" }),
    react_1.default.createElement("path", { d: "M6 11v5c0 1.5 3 3 6 3s6-1.5 6-3v-5" })));
exports.IconMapPin = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0Z" }),
    react_1.default.createElement("circle", { cx: "12", cy: "10", r: "3" })));
exports.IconDocument = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
    react_1.default.createElement("polyline", { points: "14 2 14 8 20 8" }),
    react_1.default.createElement("line", { x1: "9", y1: "13", x2: "15", y2: "13" }),
    react_1.default.createElement("line", { x1: "9", y1: "17", x2: "15", y2: "17" })));
exports.IconMegaphone = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M3 11v2a4 4 0 0 0 4 4h.5L9 21h2l1-4 7 3V8L12 11H7a4 4 0 0 0-4 0Z" }),
    react_1.default.createElement("path", { d: "M18 5v14" })));
exports.IconInformation = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    react_1.default.createElement("line", { x1: "12", y1: "16", x2: "12", y2: "12" }),
    react_1.default.createElement("line", { x1: "12", y1: "8", x2: "12.01", y2: "8" })));
exports.IconBriefcase = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("rect", { x: "2", y: "7", width: "20", height: "14", rx: "2" }),
    react_1.default.createElement("path", { d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" })));
exports.IconClipboard = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }),
    react_1.default.createElement("rect", { x: "8", y: "2", width: "8", height: "4", rx: "1" }),
    react_1.default.createElement("polyline", { points: "9 14 11 16 15 12" })));
exports.IconCheck = make(react_1.default.createElement("polyline", { points: "20 6 9 17 4 12" }));
exports.IconChevronLeft = make(react_1.default.createElement("polyline", { points: "15 18 9 12 15 6" }));
exports.IconChevronRight = make(react_1.default.createElement("polyline", { points: "9 18 15 12 9 6" }));
exports.IconArrowLeft = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("line", { x1: "19", y1: "12", x2: "5", y2: "12" }),
    react_1.default.createElement("polyline", { points: "12 19 5 12 12 5" })));
exports.IconAlertCircle = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    react_1.default.createElement("line", { x1: "12", y1: "8", x2: "12", y2: "12" }),
    react_1.default.createElement("line", { x1: "12", y1: "16", x2: "12.01", y2: "16" })));
exports.IconCreditCard = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("rect", { x: "2", y: "5", width: "20", height: "14", rx: "2" }),
    react_1.default.createElement("line", { x1: "2", y1: "10", x2: "22", y2: "10" })));
exports.IconCamera = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" }),
    react_1.default.createElement("circle", { cx: "12", cy: "13", r: "4" })));
exports.IconShield = make(react_1.default.createElement("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" }));
exports.IconInfo = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    react_1.default.createElement("line", { x1: "12", y1: "16", x2: "12", y2: "12" }),
    react_1.default.createElement("line", { x1: "12", y1: "8", x2: "12.01", y2: "8" })));
exports.IconUpload = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
    react_1.default.createElement("polyline", { points: "17 8 12 3 7 8" }),
    react_1.default.createElement("line", { x1: "12", y1: "3", x2: "12", y2: "15" })));
exports.IconPrinter = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("polyline", { points: "6 9 6 2 18 2 18 9" }),
    react_1.default.createElement("path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }),
    react_1.default.createElement("rect", { x: "6", y: "14", width: "12", height: "8", rx: "1" })));
exports.IconPencil = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M12 20h9" }),
    react_1.default.createElement("path", { d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" })));
exports.IconLock = make(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("rect", { x: "3", y: "11", width: "18", height: "11", rx: "2" }),
    react_1.default.createElement("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })));
/** Map a section.id (basic / program / family / address / education / ...) to a section icon. */
function sectionIconFor(id) {
    const map = {
        basic: exports.IconUser,
        program: exports.IconAcademicCap,
        course: exports.IconAcademicCap,
        family: exports.IconUsers,
        address: exports.IconMapPin,
        education: exports.IconDocument,
        workExperience: exports.IconBriefcase,
        referral: exports.IconMegaphone,
        extras: exports.IconInfo,
        documents: exports.IconClipboard,
        testRegistration: exports.IconClipboard,
        payment: exports.IconCreditCard,
        photo: exports.IconCamera,
        review: exports.IconShield,
        declaration: exports.IconShield,
    };
    return map[id] || exports.IconInfo;
}
exports.sectionIconFor = sectionIconFor;
/** Per-section tint colours for the icon box (bg + stroke) as specified in design. */
function sectionTintFor(id) {
    const map = {
        basic: { bg: '#ede9fe', stroke: '#6d28d9' },
        program: { bg: '#dbeafe', stroke: '#1d4ed8' },
        course: { bg: '#dbeafe', stroke: '#1d4ed8' },
        family: { bg: '#dcfce7', stroke: '#16a34a' },
        address: { bg: '#fce7f3', stroke: '#be185d' },
        education: { bg: '#fef3c7', stroke: '#d97706' },
        workExperience: { bg: '#fef3c7', stroke: '#d97706' },
        referral: { bg: '#e0f2fe', stroke: '#0369a1' },
        extras: { bg: '#f3e8ff', stroke: '#7c3aed' },
        review: { bg: '#fef9c3', stroke: '#b45309' },
        declaration: { bg: '#fef9c3', stroke: '#b45309' },
        documents: { bg: '#fef3c7', stroke: '#d97706' },
        payment: { bg: '#e0f2fe', stroke: '#0369a1' },
    };
    return map[id] || { bg: '#f1f5f9', stroke: '#475569' };
}
exports.sectionTintFor = sectionTintFor;
